import Tooltip from '@sdk/common/tooltip/Tooltip';
import gettext from '@sdk/lang/gettext';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styled from 'styled-components';

import CopyIconSvg from '@web/assets/svg/UI/copy.svg';
import GenerateSvg from '@web/assets/svg/UI/generate.svg';

const Hoverable = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 34px;
  height: 34px;
  svg {
    color: ${({ theme }) => theme.colors.iconGray};
  }

  &:hover,
  &:hover svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

type Props = {
  onCopy: () => void;
  onSubmit: (isPersonal: boolean) => void;
  text: string;
  isPersonal: boolean;
  hasChanges: boolean;
};

const ActionButton = ({ onCopy, onSubmit, text, isPersonal, hasChanges }: Props) => {
  return (
    <>
      {hasChanges || !text ? (
        <Hoverable
          data-tip={gettext('Generate')}
          data-place={'top'}
          onClick={() => onSubmit(isPersonal)}>
          <GenerateSvg />
          <Tooltip minWidth={80} />
        </Hoverable>
      ) : (
        <CopyToClipboard text={text} onCopy={onCopy}>
          <Hoverable data-tip={gettext('Copy')} data-place={'top'}>
            <CopyIconSvg />
            <Tooltip minWidth={80} />
          </Hoverable>
        </CopyToClipboard>
      )}
    </>
  );
};
export default ActionButton;
